// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"5c6d15df","859":"fa112b22"}[chunkId] + ".chunk.js";
};